export const appList =[{"plat_id":"7","app_id":"1526916","app_name":"公路狂飙跑车","package_name":"com.gzzr.glkbpc.mi","app_type":"2","package_type":"11","project_id":"7580","project_name":"公路狂飙跑车","main_app_name":"公路狂飙跑车","is_from_entry_app":"0","customer_id":"101461","value":"1526916","label":"公路狂飙跑车","num":1},{"plat_id":"7","app_id":"1524524","app_name":"球球滚滚滚","package_name":"com.gzzr.qqgggl.mi","app_type":"2","package_type":"11","project_id":"10630","project_name":"球球滚滚滚","main_app_name":"球球滚滚滚","is_from_entry_app":"0","customer_id":"101461","value":"1524524","label":"球球滚滚滚","num":0},{"plat_id":"7","app_id":"1525554","app_name":"暴走都市英雄乱斗","package_name":"com.gzzr.bzdsyxld.mi","app_type":"2","package_type":"11","project_id":"12235","project_name":"暴走都市英雄乱斗","main_app_name":"暴走都市英雄乱斗","is_from_entry_app":"0","customer_id":"101461","value":"1525554","label":"暴走都市英雄乱斗","num":0}]


export const displayType = [{"param_id":"20","param_name":"商店-搜索","type":"display_type","pid":"1_2","config":"{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}","sort":null,"required":1,"optional":"1","label":"商店-搜索","value":"20","num":0},{"param_id":"34","param_name":"商店-富媒体","type":"display_type","pid":"1_2","config":"{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}","sort":null,"required":1,"optional":"1","label":"商店-富媒体","value":"34","num":0},{"param_id":"35","param_name":"商店-推荐","type":"display_type","pid":"1_2","config":"{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}","sort":null,"required":1,"optional":"1","label":"商店-推荐","value":"35","num":0},{"param_id":"33","param_name":"商店-开屏","type":"display_type","pid":"1_2","config":"{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}","sort":null,"required":1,"optional":"1","label":"商店-开屏","value":"33","num":0},{"param_id":"32","param_name":"非商店-通知栏","type":"display_type","pid":"2_2","config":"{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}","sort":null,"required":1,"optional":"1","label":"非商店-通知栏","value":"32","num":0},{"param_id":"36","param_name":"非商店-富媒体","type":"display_type","pid":"2_2","config":"{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}","sort":null,"required":1,"optional":"1","label":"非商店-富媒体","value":"36","num":0},{"param_id":"3","param_name":"非商店-应用分发","type":"display_type","pid":"2_2","config":"{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":false}}","sort":null,"required":1,"optional":"1","label":"非商店-应用分发","value":"3","num":0},{"param_id":"37","param_name":"米盟-富媒体","type":"display_type","pid":"3_2","config":"{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}","sort":null,"required":1,"optional":"1","label":"米盟-富媒体","value":"37","num":1}]


export const materialType = [{"param_id":"1","param_name":"大图","type":"emi_material_type","pid":"3_2_37","config":null,"sort":null,"required":1,"optional":"1","value":"1","label":"大图","num":0},{"param_id":"2","param_name":"小图","type":"emi_material_type","pid":"3_2_37","config":null,"sort":null,"required":1,"optional":"1","value":"2","label":"小图","num":0},{"param_id":"5","param_name":"横版视频","type":"emi_material_type","pid":"3_2_37","config":null,"sort":null,"required":1,"optional":"1","value":"5","label":"横版视频","num":0},{"param_id":"6","param_name":"竖版视频","type":"emi_material_type","pid":"3_2_37","config":null,"sort":null,"required":1,"optional":"1","value":"6","label":"竖版视频","num":1},{"param_id":"7","param_name":"开屏图片","type":"emi_material_type","pid":"3_2_37","config":null,"sort":null,"required":1,"optional":"1","value":"7","label":"开屏图片","num":0},{"param_id":"8","param_name":"开屏视频","type":"emi_material_type","pid":"3_2_37","config":null,"sort":null,"required":1,"optional":"1","value":"8","label":"开屏视频","num":0}]

export const placementType = [{"param_id":"157","param_name":"米盟-信息流大图(应用下载)","type":"placement_type","pid":"3_2_37_1","config":"true","sort":null,"required":1,"optional":"1","value":"157","label":"米盟-信息流大图(应用下载)","num":0},{"param_id":"1002","param_name":"米盟-图文开屏广告(应用下载)","type":"placement_type","pid":"3_2_37_1","config":"true","sort":null,"required":1,"optional":"1","value":"1002","label":"米盟-图文开屏广告(应用下载)","num":0},{"param_id":"173","param_name":"米盟-图片插屏广告(应用下载)","type":"placement_type","pid":"3_2_37_1","config":"true","sort":null,"required":1,"optional":"1","value":"173","label":"米盟-图片插屏广告(应用下载)","num":0}]


export const searchConfigData = {"material_status_map":[{"id":"0","name":"未使用"},{"id":"1","name":"已使用"}],"plat_map":[{"id":"1","name":"OPPO","docking_status":"1"},{"id":"3","name":"vivo","docking_status":"1"},{"id":"4","name":"华为","docking_status":"1"},{"id":"10","name":"华为Ads","docking_status":"1"},{"id":"11","name":"荣耀","docking_status":"1"},{"id":"7","name":"小米","docking_status":"1"},{"id":"8","name":"爱奇艺","docking_status":"1"},{"id":"9","name":"Apple","docking_status":"1"},{"id":"12","name":"测试媒体","docking_status":"0"},{"id":"13","name":"6666","docking_status":"0"},{"id":"14","name":"7777","docking_status":"0"},{"id":"15","name":"8888","docking_status":"0"},{"id":"16","name":"2222","docking_status":"0"},{"id":"17","name":"42","docking_status":"0"},{"id":"19","name":"你好，这是测试媒体","docking_status":"1"}]}
console.log(displayType.map(item => item.value));
// '20', '34', '35', '33', '32', '36', '3', '37'

export const config = {
    "campaign_type": [
        {
            "param_id": "1",
            "param_name": "商店",
            "type": "campaign_type",
            "pid": "0",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "非商店",
            "type": "campaign_type",
            "pid": "0",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "3",
            "param_name": "米盟",
            "type": "campaign_type",
            "pid": "0",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "product_type": [
        {
            "param_id": "2",
            "param_name": "应用下载",
            "type": "product_type",
            "pid": "1",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "应用下载",
            "type": "product_type",
            "pid": "2",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "应用下载",
            "type": "product_type",
            "pid": "3",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "display_type": [
        {
            "param_id": "20",
            "param_name": "商店-搜索",
            "type": "display_type",
            "pid": "1_2",
            "config": "{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "34",
            "param_name": "商店-富媒体",
            "type": "display_type",
            "pid": "1_2",
            "config": "{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "35",
            "param_name": "商店-推荐",
            "type": "display_type",
            "pid": "1_2",
            "config": "{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "33",
            "param_name": "商店-开屏",
            "type": "display_type",
            "pid": "1_2",
            "config": "{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "32",
            "param_name": "非商店-通知栏",
            "type": "display_type",
            "pid": "2_2",
            "config": "{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "36",
            "param_name": "非商店-富媒体",
            "type": "display_type",
            "pid": "2_2",
            "config": "{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "3",
            "param_name": "非商店-应用分发",
            "type": "display_type",
            "pid": "2_2",
            "config": "{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":false}}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "37",
            "param_name": "米盟-富媒体",
            "type": "display_type",
            "pid": "3_2",
            "config": "{\"target\":{\"includeUserPackage\":true,\"excludeUserPackage\":true,\"installation\":true}}",
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "emi_material_type": [
        {
            "param_id": "11",
            "param_name": "应用信息",
            "type": "emi_material_type",
            "pid": "1_2_20",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1",
            "param_name": "大图",
            "type": "emi_material_type",
            "pid": "1_2_34",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "11",
            "param_name": "应用信息",
            "type": "emi_material_type",
            "pid": "1_2_35",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "7",
            "param_name": "开屏图片",
            "type": "emi_material_type",
            "pid": "1_2_33",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "9",
            "param_name": "图标",
            "type": "emi_material_type",
            "pid": "2_2_32",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "10",
            "param_name": "通知栏大图",
            "type": "emi_material_type",
            "pid": "2_2_32",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1",
            "param_name": "大图",
            "type": "emi_material_type",
            "pid": "2_2_36",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "小图",
            "type": "emi_material_type",
            "pid": "2_2_36",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "4",
            "param_name": "竖图",
            "type": "emi_material_type",
            "pid": "2_2_36",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "5",
            "param_name": "横版视频",
            "type": "emi_material_type",
            "pid": "2_2_36",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "6",
            "param_name": "竖版视频",
            "type": "emi_material_type",
            "pid": "2_2_36",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "7",
            "param_name": "开屏图片",
            "type": "emi_material_type",
            "pid": "2_2_36",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "8",
            "param_name": "开屏视频",
            "type": "emi_material_type",
            "pid": "2_2_36",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "11",
            "param_name": "应用信息",
            "type": "emi_material_type",
            "pid": "2_2_3",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1",
            "param_name": "大图",
            "type": "emi_material_type",
            "pid": "3_2_37",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "小图",
            "type": "emi_material_type",
            "pid": "3_2_37",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "5",
            "param_name": "横版视频",
            "type": "emi_material_type",
            "pid": "3_2_37",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "6",
            "param_name": "竖版视频",
            "type": "emi_material_type",
            "pid": "3_2_37",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "7",
            "param_name": "开屏图片",
            "type": "emi_material_type",
            "pid": "3_2_37",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "8",
            "param_name": "开屏视频",
            "type": "emi_material_type",
            "pid": "3_2_37",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "placement_type": [
        {
            "param_id": "26",
            "param_name": "搜索广告",
            "type": "placement_type",
            "pid": "1_2_20_11",
            "config": "false",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1044",
            "param_name": "富媒体广告",
            "type": "placement_type",
            "pid": "1_2_34_1",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "13",
            "param_name": "精品列表广告",
            "type": "placement_type",
            "pid": "1_2_35_11",
            "config": "false",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1008",
            "param_name": "应用相关推荐",
            "type": "placement_type",
            "pid": "1_2_35_11",
            "config": "false",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "12",
            "param_name": "装机必备频道广告",
            "type": "placement_type",
            "pid": "1_2_35_11",
            "config": "false",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "55",
            "param_name": "排行榜广告",
            "type": "placement_type",
            "pid": "1_2_35_11",
            "config": "false",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1043",
            "param_name": "应用商店-图片开屏",
            "type": "placement_type",
            "pid": "1_2_33_7",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1038",
            "param_name": "通知栏图标(应用下载)",
            "type": "placement_type",
            "pid": "2_2_32_9",
            "config": "false",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1037",
            "param_name": "通知栏大图(应用下载)",
            "type": "placement_type",
            "pid": "2_2_32_10",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "20",
            "param_name": "信息流大图(应用下载)",
            "type": "placement_type",
            "pid": "2_2_36_1",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "167",
            "param_name": "Banner大图(应用下载)",
            "type": "placement_type",
            "pid": "2_2_36_1",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "17",
            "param_name": "信息流小图(应用下载)",
            "type": "placement_type",
            "pid": "2_2_36_2",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1005",
            "param_name": "Banner竖屏(应用下载)",
            "type": "placement_type",
            "pid": "2_2_36_4",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "191",
            "param_name": "信息流视频(应用下载)",
            "type": "placement_type",
            "pid": "2_2_36_5",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "193",
            "param_name": "视频前贴-视频类广告(应用下载)",
            "type": "placement_type",
            "pid": "2_2_36_5",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1036",
            "param_name": "视频-信息流视频(应用下载)",
            "type": "placement_type",
            "pid": "2_2_36_5",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1034",
            "param_name": "竖版视频(应用下载)",
            "type": "placement_type",
            "pid": "2_2_36_6",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "130",
            "param_name": "图片开屏广告(应用下载)",
            "type": "placement_type",
            "pid": "2_2_36_7",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "133",
            "param_name": "视频开屏广告(应用下载)",
            "type": "placement_type",
            "pid": "2_2_36_8",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "115",
            "param_name": "精选应用推广",
            "type": "placement_type",
            "pid": "2_2_3_11",
            "config": "false",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "157",
            "param_name": "米盟-信息流大图(应用下载)",
            "type": "placement_type",
            "pid": "3_2_37_1",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1002",
            "param_name": "米盟-图文开屏广告(应用下载)",
            "type": "placement_type",
            "pid": "3_2_37_1",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "173",
            "param_name": "米盟-图片插屏广告(应用下载)",
            "type": "placement_type",
            "pid": "3_2_37_1",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "160",
            "param_name": "米盟-信息流小图(应用下载)",
            "type": "placement_type",
            "pid": "3_2_37_2",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "178",
            "param_name": "米盟-横幅广告(应用下载)",
            "type": "placement_type",
            "pid": "3_2_37_2",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1006",
            "param_name": "米盟-激励视频广告(应用下载)",
            "type": "placement_type",
            "pid": "3_2_37_5",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1042",
            "param_name": "米盟-竖版激励视频(应用下载)",
            "type": "placement_type",
            "pid": "3_2_37_6",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "175",
            "param_name": "米盟-图片开屏广告(应用下载)",
            "type": "placement_type",
            "pid": "3_2_37_7",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1020",
            "param_name": "米盟-视频开屏广告(应用下载)",
            "type": "placement_type",
            "pid": "3_2_37_8",
            "config": "true",
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "wildcard_plan_name": [
        {
            "param_id": "1",
            "param_name": "项目名称",
            "type": "wildcard_plan_name",
            "pid": "0",
            "config": "{项目名称}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "投放范围",
            "type": "wildcard_plan_name",
            "pid": "0",
            "config": "{投放范围}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "3",
            "param_name": "版位",
            "type": "wildcard_plan_name",
            "pid": "0",
            "config": "{版位}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "4",
            "param_name": "跟踪类型",
            "type": "wildcard_plan_name",
            "pid": "0",
            "config": "{跟踪类型}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "5",
            "param_name": "转化类型",
            "type": "wildcard_plan_name",
            "pid": "0",
            "config": "{转化类型}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "6",
            "param_name": "素材规格",
            "type": "wildcard_plan_name",
            "pid": "0",
            "config": "{素材规格}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "7",
            "param_name": "创建日期",
            "type": "wildcard_plan_name",
            "pid": "0",
            "config": "{创建日期}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "8",
            "param_name": "任务号-顺序号",
            "type": "wildcard_plan_name",
            "pid": "0",
            "config": "{任务号-顺序号}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "9",
            "param_name": "wk",
            "type": "wildcard_plan_name",
            "pid": "0",
            "config": "wk",
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "wildcard_adgroup_name": [
        {
            "param_id": "1",
            "param_name": "项目名称",
            "type": "wildcard_adgroup_name",
            "pid": "0",
            "config": "{项目名称}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "投放范围",
            "type": "wildcard_adgroup_name",
            "pid": "0",
            "config": "{投放范围}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "3",
            "param_name": "版位",
            "type": "wildcard_adgroup_name",
            "pid": "0",
            "config": "{版位}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "4",
            "param_name": "跟踪类型",
            "type": "wildcard_adgroup_name",
            "pid": "0",
            "config": "{跟踪类型}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "5",
            "param_name": "转化类型",
            "type": "wildcard_adgroup_name",
            "pid": "0",
            "config": "{转化类型}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "6",
            "param_name": "素材规格",
            "type": "wildcard_adgroup_name",
            "pid": "0",
            "config": "{素材规格}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "7",
            "param_name": "创建日期",
            "type": "wildcard_adgroup_name",
            "pid": "0",
            "config": "{创建日期}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "8",
            "param_name": "任务号-顺序号",
            "type": "wildcard_adgroup_name",
            "pid": "0",
            "config": "{任务号-顺序号}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "9",
            "param_name": "wk",
            "type": "wildcard_adgroup_name",
            "pid": "0",
            "config": "wk",
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "wildcard_ad_name": [
        {
            "param_id": "1",
            "param_name": "项目名称",
            "type": "wildcard_ad_name",
            "pid": "0",
            "config": "{项目名称}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "投放范围",
            "type": "wildcard_ad_name",
            "pid": "0",
            "config": "{投放范围}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "3",
            "param_name": "版位",
            "type": "wildcard_ad_name",
            "pid": "0",
            "config": "{版位}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "4",
            "param_name": "跟踪类型",
            "type": "wildcard_ad_name",
            "pid": "0",
            "config": "{跟踪类型}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "5",
            "param_name": "转化类型",
            "type": "wildcard_ad_name",
            "pid": "0",
            "config": "{转化类型}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "6",
            "param_name": "素材规格",
            "type": "wildcard_ad_name",
            "pid": "0",
            "config": "{素材规格}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "7",
            "param_name": "素材名称",
            "type": "wildcard_ad_name",
            "pid": "0",
            "config": "{素材名称}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "8",
            "param_name": "创建日期",
            "type": "wildcard_ad_name",
            "pid": "0",
            "config": "{创建日期}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "9",
            "param_name": "任务号-顺序号",
            "type": "wildcard_ad_name",
            "pid": "0",
            "config": "{任务号-顺序号}",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "10",
            "param_name": "wk",
            "type": "wildcard_ad_name",
            "pid": "0",
            "config": "wk",
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "delivery_policy": [
        {
            "param_id": "1",
            "param_name": "匀速投放",
            "type": "delivery_policy",
            "pid": "0",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "0",
            "param_name": "加速投放",
            "type": "delivery_policy",
            "pid": "0",
            "config": null,
            "sort": null,
            "required": 0,
            "optional": "1"
        }
    ],
    "auto_optimize": [
        {
            "param_id": "0",
            "param_name": "关闭",
            "type": "auto_optimize",
            "pid": "0",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "0"
        }
    ],
    "ad_prod_type": [
        {
            "param_id": "0",
            "param_name": "普通广告",
            "type": "ad_prod_type",
            "pid": "0",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "0"
        }
    ],
    "installation": [
        {
            "param_id": "-1",
            "param_name": "不限",
            "type": "installation",
            "pid": "0",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "已安装该应用",
            "type": "installation",
            "pid": "0",
            "config": null,
            "sort": null,
            "required": 0,
            "optional": "1"
        },
        {
            "param_id": "1",
            "param_name": "未安装该应用",
            "type": "installation",
            "pid": "0",
            "config": null,
            "sort": null,
            "required": 0,
            "optional": "1"
        },
        {
            "param_id": "3",
            "param_name": "已卸载该应用",
            "type": "installation",
            "pid": "0",
            "config": "请确保目标账户拥有该权限，否则会创建失败",
            "sort": null,
            "required": 0,
            "optional": "1"
        }
    ],
    "billing_type": [
        {
            "param_id": "3",
            "param_name": "下载",
            "type": "billing_type",
            "pid": "20",
            "config": "CPD",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "102",
            "param_name": "转化",
            "type": "billing_type",
            "pid": "20",
            "config": "oCPD",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "3",
            "param_name": "下载",
            "type": "billing_type",
            "pid": "35",
            "config": "CPD",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "102",
            "param_name": "转化",
            "type": "billing_type",
            "pid": "35",
            "config": "oCPD",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "3",
            "param_name": "下载",
            "type": "billing_type",
            "pid": "3",
            "config": "CPD",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "102",
            "param_name": "转化",
            "type": "billing_type",
            "pid": "3",
            "config": "oCPD",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "点击",
            "type": "billing_type",
            "pid": "36",
            "config": "CPC",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "101",
            "param_name": "转化",
            "type": "billing_type",
            "pid": "36",
            "config": "oCPC",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "1",
            "param_name": "展示",
            "type": "billing_type",
            "pid": "37",
            "config": "CPM",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "点击",
            "type": "billing_type",
            "pid": "37",
            "config": "CPC",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "101",
            "param_name": "转化",
            "type": "billing_type",
            "pid": "37",
            "config": "oCPC",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "3",
            "param_name": "下载",
            "type": "billing_type",
            "pid": "34",
            "config": "CPD",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "102",
            "param_name": "转化",
            "type": "billing_type",
            "pid": "34",
            "config": "oCPD",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "点击",
            "type": "billing_type",
            "pid": "33",
            "config": "CPC",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "101",
            "param_name": "转化",
            "type": "billing_type",
            "pid": "33",
            "config": "oCPC",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "2",
            "param_name": "点击",
            "type": "billing_type",
            "pid": "32",
            "config": "CPC",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "101",
            "param_name": "转化",
            "type": "billing_type",
            "pid": "32",
            "config": "oCPC",
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "plan_allocation_rules": [
        {
            "param_id": "app",
            "param_name": "应用",
            "type": "plan_allocation_rules",
            "pid": "0",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "0"
        },
        {
            "param_id": "campaign_type",
            "param_name": "投放范围",
            "type": "plan_allocation_rules",
            "pid": "0",
            "config": "",
            "sort": null,
            "required": 1,
            "optional": "0"
        },
        {
            "param_id": "display_type",
            "param_name": "版位",
            "type": "plan_allocation_rules",
            "pid": "0",
            "config": "",
            "sort": null,
            "required": 1,
            "optional": "0"
        },
        {
            "param_id": "tracking_type",
            "param_name": "跟踪类型",
            "type": "plan_allocation_rules",
            "pid": "0",
            "config": "",
            "sort": null,
            "required": 1,
            "optional": "0"
        },
        {
            "param_id": "union_conver_type",
            "param_name": "转化类型",
            "type": "plan_allocation_rules",
            "pid": "0",
            "config": "",
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "emi_material_type",
            "param_name": "素材规格",
            "type": "plan_allocation_rules",
            "pid": "0",
            "config": "",
            "sort": null,
            "required": 1,
            "optional": "0"
        },
        {
            "param_id": "idea_group",
            "param_name": "创意组",
            "type": "plan_allocation_rules",
            "pid": "0",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "title_min_length": [
        {
            "param_id": "26",
            "param_name": "26",
            "type": "title_min_length",
            "pid": "3",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "18",
            "param_name": "18",
            "type": "title_min_length",
            "pid": "32",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "26",
            "param_name": "26",
            "type": "title_min_length",
            "pid": "36",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "26",
            "param_name": "26",
            "type": "title_min_length",
            "pid": "37",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "product_description_min_length": [
        {
            "param_id": "15",
            "param_name": "15",
            "type": "product_description_min_length",
            "pid": "36",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "description_min_length": [
        {
            "param_id": "26",
            "param_name": "26",
            "type": "description_min_length",
            "pid": "32",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        },
        {
            "param_id": "26",
            "param_name": "26",
            "type": "description_min_length",
            "pid": "37",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "brand_min_length": [
        {
            "param_id": "10",
            "param_name": "10",
            "type": "brand_min_length",
            "pid": "36",
            "config": null,
            "sort": null,
            "required": 1,
            "optional": "1"
        }
    ],
    "price_type": [
        {
            "param_id": "25",
            "param_name": "CPM",
            "pid": "0",
            "type": "price_type",
            "config": [],
            "value": "PRICING_CPM",
            "label": "CPM"
        },
        {
            "param_id": "26",
            "param_name": "CPC",
            "pid": "0",
            "type": "price_type",
            "config": [],
            "value": "PRICING_CPC",
            "label": "CPC"
        },
        {
            "param_id": "27",
            "param_name": "CPD",
            "pid": "0",
            "type": "price_type",
            "config": [],
            "value": "PRICING_OCPD",
            "label": "oCPD"
        },
        {
            "param_id": "28",
            "param_name": "CPA",
            "pid": "0",
            "type": "price_type",
            "config": [],
            "value": "PRICING_CPA",
            "label": "CPA"
        },
        {
            "param_id": "29",
            "param_name": "oCPC",
            "pid": "0",
            "type": "price_type",
            "config": [],
            "value": "PRICING_OCPC",
            "label": "oCPC"
        },
        
    ],
    "tracking_id": [
        {
            "param_id": "1",
            "param_name": "激活",
            "type": "tracking_id",
            "pid": "0",
            "config": null,
            "sort": null,
            "value": "1",
            "label": "激活"
        },
        {
            "param_id": "2",
            "param_name": "点击",
            "type": "tracking_id",
            "pid": "0",
            "config": null,
            "sort": null,
            "value": "2",
            "label": "点击"
        },
        {
            "param_id": "3",
            "param_name": "下载",
            "type": "tracking_id",
            "pid": "0",
            "config": null,
            "sort": null,
            "value": "3",
            "label": "下载"
        },
        {
            "param_id": "4",
            "param_name": "转化",
            "type": "tracking_id",
            "pid": "0",
            "config": null,
            "sort": null,
            "value": "4",
            "label": "转化" 
        }
    ]
}
